import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import fr from 'facet-rest';
import featureEnabled from 'Helpers/Affordances';
import relationships from 'Consts/Relationships';
import MetaControl from '../Meta/MetaControl';


const GoalQuestions = ({ goalResource, className }) => {
  const [questionResources, setQuestionResources] = useState([]);

  useEffect(() => {
    if (featureEnabled(goalResource, relationships.goalFlowToggle)) {
      // set responses to readonly
      const questionMetaOverride = fr.metaOverride()
        .nameOverride('response', { readonly: true, _customProps: { color: 'primary' } });
      goalResource.relationship(relationships.goalFlowToggle).link('related').Get({ metaOverrideSet: questionMetaOverride }).then((response) => {
        const flowResource = response.resources().head();
        const questionResourcesArray = [];
        flowResource.attr('flowSteps').resources().list().forEach((flowStep) => {
          flowStep.attr('questions').resources().list().forEach((question) => {
            const responseMeta = question.meta().template().findItem(item => item.id() === 'response');
            // set prompt of response to question
            responseMeta.attr('prompt', question.attr('question'));
            questionResourcesArray.push(question);
          });
        });
        setQuestionResources(questionResourcesArray);
      });
    }
  }, [goalResource]);
  return (
    <div className={className}>
      {questionResources.map((question) => {
        return (
          <MetaControl attrName="response" resource={question} key={question.id()} />
        );
      })}
    </div>
  );
};

GoalQuestions.propTypes = {
  goalResource: PropTypes.object.isRequired,
  className: PropTypes.string.isRequired,
};

export default GoalQuestions;
